import ImagesViewerLiftedState from '../../../components/image-viewer-fls/ImageViewerFls';
import { ImagesViewerWrapper } from './ProductImage.style';

export interface ProductImageLiftedStateProps {
  prodName: string;
  prodImages: string[];
  categoriesCalculatedInfo: { name: string; href: string }[][];
  shouldBeSticky: boolean;
  handleShouldBeSticky: any;
}

const ProductImageLiftedState: React.FC<{
  data: ProductImageLiftedStateProps;
}> = ({ data }: { data: ProductImageLiftedStateProps }) => {
  const {
    prodName,
    prodImages,
    categoriesCalculatedInfo,
    shouldBeSticky,
    handleShouldBeSticky,
  } = data || {};

  const mainCategoriesCalculatedInfo = categoriesCalculatedInfo?.[0];

  const secondCategory =
    mainCategoriesCalculatedInfo?.[0] &&
    mainCategoriesCalculatedInfo?.[1] &&
    mainCategoriesCalculatedInfo?.[mainCategoriesCalculatedInfo?.[2] ? 1 : 0];
  const thirdCategory =
    mainCategoriesCalculatedInfo?.[1] &&
    mainCategoriesCalculatedInfo?.[mainCategoriesCalculatedInfo?.[2] ? 2 : 1];

  return (
    <ImagesViewerWrapper>
      <ImagesViewerLiftedState
        images={prodImages || []}
        prodName={`${secondCategory?.name ?? ''} ${
          secondCategory?.name ? '-' : ''
        } ${thirdCategory?.name ?? ''} ${thirdCategory?.name ? '-' : ''} ${
          prodName ?? ''
        } ${prodName ? '-' : ''} ${
          process?.env?.NEXT_PUBLIC_COMPANY_NAME ?? ''
        }`}
        shouldBeSticky={shouldBeSticky}
        handleShouldBeSticky={handleShouldBeSticky}
      />
    </ImagesViewerWrapper>
  );
};

export default ProductImageLiftedState;
